import type { ScheduleOperationsOverviewKpis } from '@services/api/dashboard/operations-schedule.api'
import type { DashboardMetricItemData } from '../types/dashboardMetrics.types'

export function mapScheduleOperationsDisruptionsMetrics(
  kpis: ScheduleOperationsOverviewKpis,
): DashboardMetricItemData[] {
  return [
    {
      id: 'ops-broken-appointments',
      leftLabel: 'Broken appointments',
      value: kpis.brokenAppointments,
    },
    { id: 'ops-no-show', leftLabel: 'No-show', value: kpis.noShow },
    {
      id: 'ops-reschedule-rate',
      leftLabel: 'Reschedule rate',
      value: kpis.rescheduleRate,
    },
    {
      id: 'ops-same-day-cancellations',
      leftLabel: 'Same-day cancellations',
      value: kpis.sameDayCancellations,
    },
    {
      id: 'ops-appointment-overruns',
      leftLabel: 'Appointment overruns',
      value: kpis.appointmentOverruns,
    },
    {
      id: 'ops-lost-chair-time',
      leftLabel: 'Lost chair time',
      value: kpis.lostChairTime,
    },
  ]
}

export function mapScheduleOperationsCapacityMetrics(
  kpis: ScheduleOperationsOverviewKpis,
): DashboardMetricItemData[] {
  return [
    {
      id: 'ops-open-chair-time',
      leftLabel: 'Open chair time',
      value: kpis.openChairTime,
    },
    {
      id: 'ops-unfilled-slots',
      leftLabel: 'Unfilled slots',
      value: kpis.unfilledSlots,
    },
    {
      id: 'ops-wait-list',
      leftLabel: 'Wait list patients',
      value: kpis.waitListPatients,
    },
    {
      id: 'ops-confirmations-pending',
      leftLabel: 'Confirmations pending',
      value: kpis.confirmationsPending,
    },
    {
      id: 'ops-new-patient-openings',
      leftLabel: 'New patient openings',
      value: kpis.newPatientOpenings,
    },
    {
      id: 'ops-hygiene-openings',
      leftLabel: 'Hygiene openings',
      value: kpis.hygieneOpenings,
    },
  ]
}
